import { render, staticRenderFns } from "./GroupConsentDetail.vue?vue&type=template&id=1982ee57&scoped=true&"
import script from "./GroupConsentDetail.vue?vue&type=script&lang=js&"
export * from "./GroupConsentDetail.vue?vue&type=script&lang=js&"
import style0 from "./GroupConsentDetail.vue?vue&type=style&index=0&id=1982ee57&prod&lang=css&"
import style1 from "./GroupConsentDetail.vue?vue&type=style&index=1&id=1982ee57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1982ee57",
  null
  
)

export default component.exports